import React from 'react'
import styled from "styled-components"
import Add from '@mui/icons-material/AddLink';
import InfoIcon from '@mui/icons-material/Info';
import "./cards.scss";
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom';


//#region css

const Caja = styled.div`
display: block;
position: relative;
flex-wrap: wrap;
margin-left: 20px;
min-height:  41vh;
width: 250px;
-webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.2);
box-shadow: 2px 4px 10px 1px rgba(201, 201,201 0.2);
margin-top: 100px;
border-radius: 18px;
background-color: #252525;
@media screen and (max-width:768px){
}

 `


const InfoContainer = styled.span`
  font-size: 20px;
  font-weight: bold;
  margin-left: 3px;
  padding: 10px;
  text-transform: uppercase;
  color: #eee;
  @media screen and (max-width:768px){
}
`

const InfoDesc = styled.div`
display: absolute;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
  text-transform: uppercase;
  margin-left: 6px;
  padding: 6px;
  width: 200px;
  height: 20%;
  color: #eee;
  @media screen and (max-width:768px){
}
  
`
//#endregion


const Cartas = (item) => {

  console.log(item.item.name);
  const eventName = item.item.name;

  const handleCopy = (e) => {
    e.preventDefault();
    const baseUrl = "https://moha-eventos.web.app/" + eventName;
    const textarea = document.createElement("textarea");

    textarea.value = baseUrl;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    textarea.remove();

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    
    Toast.fire({
      icon: 'success',
      title: 'Link copiado!'
    })


  }
  return (
    <div>
      <Caja>
        <InfoContainer>{item.item.name.toUpperCase().replace(/-/g, ' ')}</InfoContainer>
        <InfoDesc>{item.item.description}</InfoDesc>
        <div className='container'>
          <Link to={`/admin/eventos/${item.item.id}`} className='informacion'><InfoIcon className='icon1'/></Link>
            <button className='addlink' onClick={(e) => handleCopy(e)}><Add className='icon'/></button>
        </div>
      </Caja>
    </div>
  )

}
// .replace(/-/g, ' ')
export default Cartas